import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ACCOUNT_SELECTION_FEATURE } from './account-selection.selectors';
import { accountSelectionReducer } from './account-selection.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AccountSelectionEffects } from './account-selection-store.effects';
import { AccountSelectionService } from '../account-selection.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(ACCOUNT_SELECTION_FEATURE, accountSelectionReducer),
    EffectsModule.forFeature([AccountSelectionEffects]),
  ],
  providers: [AccountSelectionService],
})
export class AccountSelectionStoreModule {}
